// Copyright (C) 2023-2024 Skylark Drones

import v4Api from '@/config/v4Api'

export const v4ApiInstance = new v4Api()

// Base Backend API
export default v4ApiInstance
